import React from "react";
import { Modal, Button } from "react-bootstrap";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { SHOP_CONFIG } from "../shop.config";
import * as S from "./styles";

export interface ShopUpsellModalProps {
  show: boolean;
  onClose: () => void;
  onContinueToShop: () => void;
  /** When true, show shop pitch + Continue to Shop. When false, success + dismiss only. */
  showShopCta?: boolean;
  title?: string;
  subtitle?: string;
  note?: string;
  pitchTitle?: string;
  pitchBody?: string;
  primaryCta?: string;
  secondaryCta?: string;
  dismissCta?: string;
}

export const ShopUpsellModal: React.FC<ShopUpsellModalProps> = ({
  show,
  onClose,
  onContinueToShop,
  showShopCta = false,
  title = SHOP_CONFIG.upsell.title,
  subtitle = SHOP_CONFIG.upsell.subtitle,
  note = SHOP_CONFIG.upsell.note,
  pitchTitle = SHOP_CONFIG.upsell.pitchTitle,
  pitchBody = SHOP_CONFIG.upsell.pitchBody,
  primaryCta = SHOP_CONFIG.upsell.primaryCta,
  secondaryCta = SHOP_CONFIG.upsell.secondaryCta,
  dismissCta = SHOP_CONFIG.upsell.dismissCta,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="shop-upsell-modal"
    >
      <S.ModalBody>
        <S.SuccessIconWrap>
          <CheckCircleIcon width={56} height={56} color="#16a34a" />
        </S.SuccessIconWrap>

        <S.Title>{title}</S.Title>
        <S.Subtitle>{subtitle}</S.Subtitle>
        {note ? <S.Note>{note}</S.Note> : null}

        {showShopCta ? (
          <>
            <S.Divider />
            <S.PitchTitle>{pitchTitle}</S.PitchTitle>
            <S.PitchBody>{pitchBody}</S.PitchBody>
            <S.Actions>
              <Button
                style={S.primaryButtonStyle}
                onClick={onContinueToShop}
                className="w-100"
              >
                {primaryCta}
              </Button>
              <Button
                variant="link"
                style={S.secondaryButtonStyle}
                onClick={onClose}
                className="w-100"
              >
                {secondaryCta}
              </Button>
            </S.Actions>
          </>
        ) : (
          <S.Actions style={{ marginTop: 20 }}>
            <Button
              style={S.primaryButtonStyle}
              onClick={onClose}
              className="w-100"
            >
              {dismissCta}
            </Button>
          </S.Actions>
        )}
      </S.ModalBody>
    </Modal>
  );
};
